export default "__VITE_ASSET__lO87e$Fg__"